import { createContext, useContext, useState, type ReactNode } from 'react';

interface CaptureContextType {
  isCaptureOpen: boolean;
  setIsCaptureOpen: (open: boolean) => void;
}

const CaptureContext = createContext<CaptureContextType | undefined>(undefined);

export const CaptureProvider = ({ children }: { children: ReactNode }) => {
  const [isCaptureOpen, setIsCaptureOpen] = useState(false);

  return (
    <CaptureContext.Provider
      value={{
        isCaptureOpen,
        setIsCaptureOpen,
      }}
    >
      {children}
    </CaptureContext.Provider>
  );
};

export const useCapture = () => {
  const context = useContext(CaptureContext);
  if (!context) {
    throw new Error('useCapture must be used within CaptureProvider');
  }
  return context;
};
